import { camelCase } from './util.js'
import greatWall from './honours/greatWall.js'
import jiangsu from './honours/jiangsu.js'
import nanjing from './honours/nanjing.js'

let works = {
  'greatwall': {
    name: '中国国际广告节 长城奖',
    icon: camelCase('honour-medal'),
    sources: greatWall
  },
  'jiangsu': {
    name: '江苏省 优秀作品奖',
    icon: camelCase('honour-medal'),
    sources: jiangsu
  },
  'nanjing': {
    name: '南京市 优秀作品奖',
    icon: camelCase('honour-medal'),
    sources: nanjing
  }
}

export default works
